document.addEventListener('DOMContentLoaded', function () {
  var customerMessagesSwiper = document.querySelector('.customer__messages--area');
  if(customerMessagesSwiper) {
    const customerSwiper = new Swiper(customerMessagesSwiper, {
      slidesPerView: 1.05,
      spaceBetween: 8,
      pagination: {
        el: '.customer-message-pagination',
        clickable: true,
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
    function updateSelection(value) {
        // dropdown-item tıklama işlemi
        document.querySelectorAll(".dropdown-item").forEach((item) => {
            if (item.getAttribute("data-value") === value) {
                item.click();
            }
        });

        // variant-input radio seçme işlemi
        document.querySelectorAll(".variant-input").forEach((variant) => {
            if (variant.getAttribute("data-value") === value) {
                let radio = variant.querySelector("input[type='radio']");
                if (radio) {
                    radio.checked = true;
                }
            }
        });
    }

    document.querySelectorAll(".sticky-add-to-cart__select-wrapper select").forEach((select) => {
        select.addEventListener("change", function () {
            let selectedValue = this.value;
            updateSelection(selectedValue);
        });
    });

    document.querySelectorAll(".dropdown-item").forEach((item) => {
        item.addEventListener("click", function () {
            let selectedValue = item.getAttribute("data-value");

            document.querySelectorAll(".sticky-add-to-cart__select-wrapper select").forEach((select) => {
                select.value = selectedValue;
            });

            updateSelection(selectedValue);
        });
    });

    document.querySelectorAll(".variant-input").forEach((variant) => {
        let radio = variant.querySelector("input[type='radio']");
        if (radio) {
            radio.addEventListener("change", function () {
                let selectedValue = variant.getAttribute("data-value");

                document.querySelectorAll(".sticky-add-to-cart__select-wrapper select").forEach((select) => {
                    select.value = selectedValue;
                });

                updateSelection(selectedValue);
            });
        }
    });

    // sticky-add-to-cart__button tıklanınca add-to-cart butonuna tıkla
    document.querySelectorAll(".sticky-add-to-cart__button").forEach((button) => {
        button.addEventListener("click", function () {
            let addToCartButton = document.querySelector(".add-to-cart");
            if (addToCartButton) {
                addToCartButton.click();
            }
        });
    });
});

